import React from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import CustomSelect from "../../../Common/CustomSelect";
import FormByKpiIndicators from "./FormByKpiIndicators";
import PropTypes from "prop-types";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import CheckboxCollapse from "../../../Common/CheckboxCollapse";
import SelectWithInput from "../../../Common/SelectWithInput";
import { AvField } from "availity-reactstrap-validation";

const AgencyCommissionForm = ({
  offer_data,
  cost,
  isFormSubmit,
  isLoading,
  suffix,
  setGroups,
  offer,
}) => {
  const [kpiIndicator, setKpiIndicator] = React.useState(
    cost?.a_c__kpi_indicator
  );
  const [isKpiIndicator, setIsKpiIndicator] = React.useState(
    !!cost?.a_c__kpi_indicator
  );

  const kpi_indicator_options = [
    { label: "Retention", value: "RR" },
    { label: "Conversion", value: "CR" },
    { label: "Event cost", value: "Event_cost" },
    { label: "Return on Ad Spend", value: "ROAS" },
    { label: "CPI", value: "CPI" },
    { label: "Average order value", value: "AOV" },
  ];

  const currency_type_options = [
    { label: "Avg per month", value: "Avg_per_month" },
    { label: "Last date", value: "Last_date" },
  ];

  const handleChangeKPI = val => {
    setKpiIndicator(val.value);
    setGroups(prev => {
      return prev.map(i => {
        if (`|${i.suffix}|` !== suffix) return i;

        return {
          ...i,
          suffix: Math.round(Math.random() * 10000).toString(),
          a_c__kpi_indicator: val.value,
        };
      });
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Agency commission %:</Label>
            <AvField
              name={"a_c__percent" + suffix}
              className="form-control"
              placeholder="Agency commission"
              value={cost?.a_c__percent || ""}
              type="number"
              errorMessage={"Agency commission field is required!"}
              validate={{ required: { value: true } }}
              // id=""
              // onChange={(e, v, d) => console.log({ e, v, d })}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Currency type:</Label>
            <CustomSelect
              name={"currency_type"}
              options={currency_type_options}
              defaultValue={
                getDefaultValueForSelect(offer?.currency_type) ||
                currency_type_options[0]
              }
              placeholder="Currency type..."
              classNamePrefix="select2-selection"
              errorMessage="Currency type field is required"
              required
              isLoading={isLoading}
              isFormSubmit={isFormSubmit}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"a_c__kpi_indicator-checkbox" + suffix}
              title="KPI indicator"
              defaultChecked={!!cost?.a_c__kpi_indicator}
              onChange={val => setIsKpiIndicator(val)}
            >
              <CustomSelect
                name={"a_c__kpi_indicator" + suffix}
                options={kpi_indicator_options}
                defaultValue={getDefaultValueForSelect(
                  cost?.a_c__kpi_indicator
                )}
                placeholder="Select KPI indicator..."
                classNamePrefix="select2-selection"
                errorMessage="KPI indicator field is required"
                onChange={handleChangeKPI}
                required
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
        <Col sm={6}>
          {isKpiIndicator && (
            <FormGroup className="mb-3">
              <CheckboxCollapse
                id={"cohort-days-id" + suffix}
                title="Cohort days"
                defaultChecked={!!cost?.a_c__kpi_is_cohort}
              >
                <AvField
                  name={"a_c__kpi_cohort_days_quantity" + suffix}
                  placeholder="Cohort days"
                  type="number"
                  value={cost?.a_c__kpi_cohort_days_quantity || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a cohort days",
                    },
                    min: {
                      value: 0,
                      errorMessage: "The cohort cannot be negative",
                    },
                  }}
                />
              </CheckboxCollapse>
            </FormGroup>
          )}
        </Col>
      </Row>
      {isKpiIndicator && (
        <FormByKpiIndicators
          kpiIndicator={kpiIndicator}
          cost={cost}
          suffix={suffix}
          prefix="a_c"
          isLoading={isLoading}
          isFormSubmit={isFormSubmit}
        />
      )}
    </React.Fragment>
  );
};

AgencyCommissionForm.propTypes = {
  cost: PropTypes.any,
  kpi_indicator_options: PropTypes.any,
  isFormSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  suffix: PropTypes.string,
  setGroups: PropTypes.func,
  offer_data: PropTypes.any,
  offer: PropTypes.any,
};

export default AgencyCommissionForm;
